module.exports = __webpack_public_path__ + "18dd44c31913c700286847d48e6a4283.png";